import { configureStore } from "@reduxjs/toolkit";
import productsReducer from "../slices/productsSlice";
import diffReducer from "../slices/diffSlice";
import accountsReducer from "../slices/accountsSlice";
import excelReducer from "../slices/excelSlice";

const ACCOUNTS_STATE_KEY = "magento_connector_accounts_state";

function loadAccountsState() {
  try {
    const serialized = localStorage.getItem(ACCOUNTS_STATE_KEY);
    if (serialized === null) return undefined;
    return JSON.parse(serialized);
  } catch (e) {
    console.warn("Failed to load accounts state from localStorage:", e);
    return undefined;
  }
}

function saveAccountsState(state: any) {
  try {
    const serialized = JSON.stringify(state);
    localStorage.setItem(ACCOUNTS_STATE_KEY, serialized);
  } catch (e) {
    console.warn("Failed to save accounts state to localStorage:", e);
  }
}

const preloadedState = {
  accounts: loadAccountsState(),
};

const store = configureStore({
  reducer: {
    products: productsReducer,
    diffs: diffReducer,
    accounts: accountsReducer,
    excel: excelReducer,
  },
  preloadedState,
});

store.subscribe(() => {
  saveAccountsState(store.getState().accounts);
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
